import { render, staticRenderFns } from "./ccm-course-dashboard.vue?vue&type=template&id=3bd256da&"
import script from "./ccm-course-dashboard.vue?vue&type=script&lang=js&"
export * from "./ccm-course-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports